import { render, staticRenderFns } from "./PaymentBadges.vue?vue&type=template&id=3540e311&scoped=true"
var script = {}
import style0 from "./PaymentBadges.vue?vue&type=style&index=0&id=3540e311&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540e311",
  null
  
)

export default component.exports